import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "../../../comn";
import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";

export const BASE = {
    path: `${ptlEnvs.base}/elctdoc/gway`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/elctdoc/gways`,
};

export const URLS = {
    ptli0706001q: `${BASE.path}/ptli0706001q`, // list
    ptli0706002s: `${BASE.path}/ptli0706002s`, // regist
    ptli0706003s: `${BASE.path}/ptli0706003s`, // modification
};

export const APIS = {
    // Insert Gateway !== 게이트웨이 등록 ==!
    insertElctDocGway: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },
    // Update Gateway !== 게이트웨이 수정 ==!
    updateElctDocGway: (data: any) => {
        return api.put(`${BASE.api}`, {
            ...data,
        });
    },
    // Delete Gateway !== 게이트웨이 삭제 ==!
    deleteElctDocGway: (gwayId: any) => {
        return api.delete(`${BASE.api}/${gwayId}`);
    },
    // Get a list of Gateway. !== 게이트웨이 목록을 조회한다.==!
    getElctDocGwayList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Get Gateway details. !== 게이트웨이 상세정보 조회 ==!
    getElctDocGway: (gwayId: any) => {
        return api.get(`${BASE.api}/${gwayId}`);
    },
};

export const SF_GWAY_MGMT_SRCH: TFormSchema = {
    id: "form_gwayMgmtSrch",
    schema: {
        gwayId: {
            type: "text",
            label: "L_GWAY_ID",
        },
        gwayUrlAddr: {
            type: "text",
            label: "L_URL_ADDR",
        },
    },
};

export const SG_GWAY_MGMT_LIST: TGridSchema = {
    id: "grid_gwayMgmtList",
    options: { pagination: "out", index: true },
    head: [
        // { cells: [{ header: "L_BSOP_CLSF_NM", binding: "gwayBsopClsfCd" }], show: false },
        // { cells: [{ header: "L_BSOP_CLSF_NM", binding: "gwayBsopClsfCdNm", width: "15%" }] },
        // { cells: [{ header: "L_API_KEY", binding: "gwayApiKey", width: "*" }] },
        { cells: [{ header: "L_GWAY_ID", binding: "gwayId", width: "15%" }] },
        { cells: [{ header: "L_URL_ADDR", binding: "gwayUrlAddr", width: "40%" }] },
        { cells: [{ header: "L_CLNT_ID", binding: "clntId", width: "15%" }] },
        { cells: [{ header: "L_FRST_REGST_ID", binding: "frstRegstId", width: "15%" }] },
        { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: "15%" }] },
    ],
    body: [
        // { cells: [{ binding: "gwayBsopClsfCd" }] },
        // { cells: [{ binding: "gwayBsopClsfCdNm" }] },
        // { cells: [{ binding: "gwayApiKey", align: "left" }] },
        { cells: [{ binding: "gwayId", align: "left" }] },
        { cells: [{ binding: "gwayUrlAddr", align: "left" }] },
        { cells: [{ binding: "clntId", align: "left" }] },
        { cells: [{ binding: "frstRegstId" }] },
        { cells: [{ binding: "frstRgsrDtm", type: "datetime" }] },
    ],
};

export const SF_GWAY_MGMT_INFO: TFormSchema = {
    id: "form_docBoxMgmtInfo",
    schema: {
        gwayId: { type: "text", label: "L_GWAY_ID", required: true },
        gwayApiKey: { type: "textarea", label: "L_API_KEY" },
        gwayUrlAddr: { type: "text", label: "L_URL_ADDR", required: true },
        clntId: { type: "text", label: "L_CLNT_ID", required: true },
        clntSecrtKeyValue: { type: "text", label: "L_CLNT_SECRT_KEY_VALUE", required: true },
        frstRegstId: { type: "text", label: "L_FRST_REGST_ID", readOnly: true },
        frstRgsrDtm: { type: "datetime", label: "L_FRST_RGSR_DTM", readOnly: true },
    },
};
